import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    ProjectProps,
    ProjectUserList,

    LoadProjectById,
    LoadProjectUsers,
    LoadProjectUserGroups,
    LoadProjectPermissions,
    LoadProjectSettings,
    GetProjectViewAccess,

    setProjectView,
    setProjectUserList,
    setSystemProjectUserGroups,
    setSystemProjectPermissions,
    setProjectProjectSettings,
    setCcRequirementDictionariesLoaded,
    renderProjectContent,
    initProject,
    initProjectSettings,
} from "client/store"
import {
    ProjectLayout,
    ProjectContentColumn,
    ProjectContentWrapper,
} from "client/parts/projectLayout"
import { Loader } from "client/components"

import { CreateRoutes } from "client/parts/routes"
import ProjectMenu from "client/parts/projectMenu"
import ProjectContent from "client/parts/projectContent"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"


const View = ({
    projectId = null,
}: ProjectProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const reloadView = useSelector((state: StoreType) => state.project.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const renderContent = useSelector((state: StoreType) => state.system.renderProjectContent)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const { projectRoutes } = CreateRoutes()

    useEffect(() => (
        // clear project on unmount
        () => {
            dispatch(setProjectView(initProject))
            dispatch(setSystemProjectUserGroups(projectId, null))
            dispatch(setSystemProjectPermissions(projectId, null))
            dispatch(setProjectProjectSettings(initProjectSettings))
            dispatch(setCcRequirementDictionariesLoaded(false))
            dispatch(renderProjectContent(false))
        }
    ), [])

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        Promise.all([
            LoadProjectUsers(projectId).then((res) => {
                const newProjectUserList: ProjectUserList = { [projectId]: res }
                dispatch(setProjectUserList(newProjectUserList))
            }),
            LoadProjectUserGroups(userData.userId, userData.accountId, projectId)
            .then((projectGroupIds) => {
                dispatch(setSystemProjectUserGroups(projectId, projectGroupIds))
            }),
            LoadProjectPermissions(userData.accountId, projectId)
            .then((permissions) => {
                dispatch(setSystemProjectPermissions(projectId, permissions.permissions))
            }),
            LoadProjectSettings(projectId).then((settings) => {
                dispatch(setProjectProjectSettings(settings))
            }),
        ]).then(() => {
            LoadProjectById(projectId, userData.accountId).then((res) => {
                dispatch(setProjectView(res))
                setLoadState(IDLE)
            })
        })
    }, [reloadView])

    const allowedToView = GetProjectViewAccess(projectId)

    if (!project) return <NotFound />
    if (!allowedToView) return <AccessDenied />

    return (
        <ProjectLayout>
            <ProjectMenu routes={projectRoutes} />

            <ProjectContentColumn>
                <ProjectContentWrapper>
                    {
                        loadState === PENDING
                        && <Loader />
                    }
                    {
                        renderContent
                        && project.id
                        && <ProjectContent />
                    }
                </ProjectContentWrapper>
            </ProjectContentColumn>
        </ProjectLayout>
    )
}
export default View
